export default __webpack_public_path__ + "static/1-9547d1ee546b2e7e962ed7713e2f654f.jpeg";